import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiGetCall, apiPostCall, apiPostCall1} from "../utilities/site-apis";
import  {axiosPOSTCall, axiosGETCall, }  from "../utilities/utils/apiPost";

const initialState = {
  isFetching: false,
  combinedRedux: {},
  septateCombinedRedux: {},
  healthData: [],
  healthQuote: [],
  success: false,
  error: false,
}

// main API call for the health insurance
export const healthEnquiryAPI = createAsyncThunk(
  "healthInsurance/healthEnquiryAPI",
  async (params, { rejectWithValue }) => {
    const response = await apiGetCall(`/health/enquiry/` + params.enquiryId, params);

      console.log('response',response.data);
    if (response.data.status === "error") {
      return rejectWithValue(response.data.data);
    }
    console.log("response.data ", response.data);
    return response.data;
  }
);

export const getHealthEnquiryAPI = createAsyncThunk(
  "healthInsurance/getHealthEnquiryAPI",
  async (params, { rejectWithValue }) => {
    // console.log("🚀 ~ params:33333", params)
    const response = await apiGetCall(`/health/enquiry/` + params.enquiryId, params);

      // console.log('response 99999',response.data);
    if (response.data.status === "error") {
      return rejectWithValue(response.data.data);
    }
    return response.data;
  }
);

export const updateCombinedModel = createAsyncThunk(
  "lifeReduxSlice/updateCombinedModel",
  async (params, { rejectWithValue }) => {
    return params;
  }
);



export const updateFirstPageData = createAsyncThunk(
  'healthInsurance/updateFirstPageData',
  async (params, { rejectWithValue }) => {
    let response;
    response = await apiPostCall1(`/health/enquiry`, params);
    // console.log('response1',response)

    // if error
    if (response.data.status === 'error') {
      return rejectWithValue(response.data.data);
    }

    // console.log("response.data ", response.data);
    console.log({ response1: response });
    return response.data.data;
  }
);


// for the HDFC life addons...
export const addonsUpdateHdfc = createAsyncThunk(
  'life/addonsUpdateHdfc',async(param,{rejectWithValue})=>{
    const response = await apiPostCall(
      '/lifeInsurance/life/quote/life-hdfc',param
    );
    if(response.data.status === "error") {
      return rejectWithValue(response.data)
    } else {
      return response.data
    }
  }
)

// Rider for the TATA MRSS
export const addonsUpdateTataMrs = createAsyncThunk(
  'life/addonsUpdateTataMrs',async(param,{rejectWithValue})=>{
    const response = await apiPostCall(
      '/lifeInsurance/life/quote/tata-mrss',param
    );
    if(response.data.status === "error") {
      return rejectWithValue(response.data)
    } else {
      return response.data
    }
  }
)


// for FG health insurance
export const fgHealthQuote = createAsyncThunk(
  'fgHealthQuote/quote',
  async (params, { rejectWithValue }) => {
    const response = await apiPostCall(
      `/healthInsurance/health/quote/health-fg`,
      params
    );
    if (response.data.status === 'error') {
      return rejectWithValue(response.data);
    }
    if (params.newData == 'new') {
      var obj2 = {
        ...response.data,
        ...{
          newData: params.newData,
        },
      };
      return obj2;
    } else {
      return response.data;
    }
  }
);

export const fgHealthProposal = createAsyncThunk(
  'fgHealthProposal/proposal',
  async (params, { rejectWithValue }) => {
    const response = await apiPostCall(
      `/healthInsurance/health/saveProposal/health-fg`,
      params
    );
    if (response.data.status === 'error') {
      return rejectWithValue(response.data);
    }
    if (params.newData == 'new') {
      var obj2 = {
        ...response.data,
        ...{
          newData: params.newData,
        },
      };
      return obj2;
    } else {
      return response.data;
    }
  }
);



export const resetRedux = createAsyncThunk(
  'healthInsurance/resetRedux',
  async (params, { rejectWithValue }) => {
    return 0;
  }
);

export const resetHealthQuoteRedux = createAsyncThunk(
  'healthInsurance/resetHealthQuoteRedux',
  async (params, { rejectWithValue }) => {
    return 0;
  }
);







export const counterSlice = createSlice({
  name: 'healthReduxSlice',
  initialState,
  reducers: {
    setHealthInsurance: (state, action) => {
      state.healthData = action.payload;
    },
    removeHealthQuoteBySlug: (state, action) => {
      const slugToRemove = action.payload;
      state.healthQuote = state.healthQuote.filter(
        (entry) => entry.slug !== slugToRemove
      );
    },
  },

  extraReducers: {
    [getHealthEnquiryAPI.pending]: (state) => {
      state.isFetching = true;
      state.error = false;
      state.success = false;
    },
    [getHealthEnquiryAPI.rejected]: (state, action) => {
      state.isFetching = false;
      state.error = true;
      state.success = false;
    },
    [getHealthEnquiryAPI.fulfilled]: (state, action) => {
      state.isFetching = false;
      state.septateCombinedRedux = action.payload.data;
      state.success = true;
      state.error = false;
    },

    [updateFirstPageData.pending]: (state, action) => {
      state.isFetching = true;
      state.error = false;
      state.success = false;
    },
    [updateFirstPageData.rejected]: (state, action) => {
      state.isFetching = false;
      state.error = true;
      state.success = false;
    },
    [updateFirstPageData.fulfilled]: (state, action) => {
      state.isFetching = false;
      state.septateCombinedRedux = action.payload;
      state.success = true;
      state.error = false;
      // state.combinedRedux = action.payload;
    },

    // Combine redux
    [healthEnquiryAPI.pending]: (state, action) => {
      state.isFetching = true;
    },
    [healthEnquiryAPI.rejected]: (state, action) => {
      state.isFetching = false;
    },
    [healthEnquiryAPI.fulfilled]: (state, action) => {
      var payload = action.payload.data;
      console.log('action.payload.data', payload);
      state.septateCombinedRedux = action.payload.data;
      state.combinedRedux = action.payload.data;
      state.success = true;
      state.error = false;
    },

    [fgHealthQuote.pending]: (state, action) => {
      state.isFetching = true;
    },
    [fgHealthQuote.rejected]: (state, action) => {
      state.error = true;
    },
    [fgHealthQuote.fulfilled]: (state, action) => {
      const existingIndex = state.healthQuote.findIndex(
        (obj) => obj.slug === 'health-fg'
      );

      if (existingIndex !== -1) {
        // If the object with the slug "tata-mrss" already exists, update it
        state.healthQuote[existingIndex] = action.payload.data;
      } else {
        // If it doesn't exist, add the new data to the array
        state.healthQuote = [...state.healthQuote, { ...action.payload.data }];
      }

      state.success = true;
      state.error = false;
      state.isFetching = false;
    },

    [fgHealthProposal.pending]: (state, action) => {
      state.isFetching = true;
    },
    [fgHealthProposal.rejected]: (state, action) => {
      state.error = true;
    },
    [fgHealthProposal.fulfilled]: (state, action) => {
      const existingIndex = state.healthQuote.findIndex(
        (obj) => obj.slug === 'health-fg'
      );

      if (existingIndex !== -1) {
        // If the object with the slug "tata-mrss" already exists, update it
        state.healthQuote[existingIndex] = action.payload.data;
      } else {
        // If it doesn't exist, add the new data to the array
        state.healthQuote = [...state.healthQuote, { ...action.payload.data }];
      }

      state.success = true;
      state.error = false;
      state.isFetching = false;
    },

    //HDFC addons update
    [addonsUpdateHdfc.rejected]: (state, action) => {
      state.error = true;
    },
    [addonsUpdateHdfc.fulfilled]: (state, action) => {
      const existingIndex = state.lifeQuote.findIndex(
        (obj) => obj.slug === 'life-hdfc'
      );
      if (existingIndex !== -1) {
        // If the object already exists, update it
        state.lifeQuote[existingIndex] = action.payload.data;
      }
      state.success = true;
      state.error = false;
    },

    // TATA MRSS addons update
    [addonsUpdateTataMrs.rejected]: (state, action) => {
      state.error = true;
    },
    [addonsUpdateTataMrs.fulfilled]: (state, action) => {
      const existingIndex = state.lifeQuote.findIndex(
        (obj) => obj.slug === 'tata-mrss'
      );
      if (existingIndex !== -1) {
        // If the object already exists, update it
        state.lifeQuote[existingIndex] = action.payload.data;
      }
      state.success = true;
      state.error = false;
    },

    [resetHealthQuoteRedux.fulfilled]: (state, action) => {
      state.healthQuote = [];
    },
  },
});

export const { setHealthInsurance, removeHealthQuoteBySlug } = counterSlice.actions;
export default counterSlice.reducer;
